import { Injectable } from '@angular/core';

import { StringInterpolationPipe } from '@frontend/sports/common/core/utils/string-interpolation';
import { TrackingService, trackingConstants } from '@frontend/sports/tracking/feature';

import { ISlip } from '../../../bet-generation/models';
import { BetslipError } from '../../errors/betslip-error';
import { ClientErrorType } from '../../errors/client-error-type';
import { RewardValidationTracking } from '../../models/reward-validation-tracking.model';

@Injectable()
export class ErrorTrackingService {
    constructor(
        protected trackingService: TrackingService,
        private stringInterpolationPipe: StringInterpolationPipe,
    ) {}

    // This was refactored from the betslip-validation service but the logic still seems to be off
    // Just taking the first error and the first slip is not a good approach, they aren't even necessarily related
    trackErrors(betslipErrors: BetslipError[], slips: ISlip[]): void {
        if (betslipErrors.length === 0 || slips.length === 0) {
            return;
        }

        const error = this.getTrackingMessage(betslipErrors[0].type as ClientErrorType, slips[0].type.key);

        if (!error) {
            return;
        }

        this.trackRewardTokenError(error);
    }

    private trackRewardTokenError(error: string) {
        const trackData = {
            [trackingConstants.PAGE_BETSLIP_ERROR]: error,
        };
        this.trackingService.track(trackingConstants.EVENT_BETSLIP_ERROR, trackData);
    }

    private getTrackingMessage(type: ClientErrorType, slipType: string): string | undefined {
        switch (type) {
            case ClientErrorType.RewardTokensTotalOddsError:
                return RewardValidationTracking.TotalOdds;
            case ClientErrorType.RewardTokensSelectionLevelOddsError:
                return RewardValidationTracking.SelectionLevelMinimumOdds;
            case ClientErrorType.RewardTokensMinLegsError:
                return RewardValidationTracking.MinimumLegs;
            case ClientErrorType.RewardTokensMinStakeError:
                return RewardValidationTracking.MinimumStake;
            case ClientErrorType.RewardTokensSlipTypeError:
                return this.stringInterpolationPipe.transform(RewardValidationTracking.SlipType, { criteria: slipType });
            default:
                return undefined;
        }
    }
}
